// extracted by mini-css-extract-plugin
export default {"TableWrapper":"DataTable_TableWrapper__W1Sgv"};